import { IReportIndex } from '@viabizzuno/models';
import { getLayout } from '@viabizzuno/models/server';
import { LayoutDefault } from '@viabizzuno/ui';
import { getPageProps } from '@viabizzuno/ui/server';
import { asEquatable, IStaticContext, PageProps } from '@websolutespa/bom-core';
import { getPage, getStaticPathsForSchema } from '@websolutespa/bom-mixer-models/server';
import { LazyLoader, OpenGraph, StructuredData } from '@websolutespa/bom-mixer-ui';
import { GetStaticPropsResult } from 'next';

export default function ReportIndex({ layout, page, params }: PageProps<IReportIndex>) {
  return (
    <>
      <LazyLoader components={page.components} />
      <StructuredData />
      <OpenGraph item={(metaData) => ({
        ...metaData.openGraph,
        image: page.media?.url,
      })} />
    </>
  );
}

ReportIndex.Layout = LayoutDefault;

export async function getStaticProps(context: IStaticContext): Promise<GetStaticPropsResult<PageProps<IReportIndex>>> {
  const id = asEquatable(context.params.id);
  const market = context.params.market;
  const locale = context.params.locale;
  const layout = await getLayout(market, locale);
  const page = await getPage<IReportIndex>('report_index', id, market, locale, context);
  /*
  const items = await getHomepages({ market, locale });
  console.log(items.length);
  */
  if (!page) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const components = page.components || [];
  components.push({
    schema: 'block_report_hero',
  });
  components.push({
    schema: 'block_report_listing',
  });
  page.components = components;

  const props = await getPageProps({ ...context, layout, page });
  return {
    props,
    /*
    * Next.js will attempt to re-generate the page when a request comes in at most once every 60 seconds
    */
    revalidate: 60 * 60 * 2, // revalidate
  };
}

export async function getStaticPaths() {
  const paths = await getStaticPathsForSchema('report_index');
  return {
    paths,
    fallback: 'blocking', // runs before initial render
    // fallback: true, // runs in the background
  };
}
